import React, { MouseEventHandler, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from "../../../components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormLabel,
  FormItem,
  FormDescription,
  FormMessage,
} from "../../../components/ui/form";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  AppointmentPrescriptionSchema,
  AppointmentPrescriptionSchemaType,
  defaultPrescriptionValues,
} from "../../../utils/global-types";
import { z } from "zod";
import { Category } from "./Category";
import dayjs from "dayjs";
import { Button } from "../../../components/ui/button";
import { GenericName } from "./GenericName";
import { DrugName } from "./DrugName";
import { Separator } from "../../../components/ui/separator";
import { Combobox } from "../../../components/ui/combobox";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../../components/ui/select";
import { PrescriptionFrequency } from "./PrescriptionFrequency";
import { PrescriptionLength } from "./PrescriptionLength";
import { Notes } from "./Notes";
import { toast } from "react-toastify";
import { addNewPrescriptionAppointment } from "../../../services/prescriptionAppointmentService";
import { searchBrandDrugNames } from "../../../services/brandDrugNameService";
import { IoMdAdd } from "react-icons/io";
import BrandNamePrescription from "./BrandNamePrescription";

export function SingleLinePrescription({
  appointmentId,
  getPrescriptionData,
}: {
  appointmentId: string | undefined;
  getPrescriptionData: any;
}) {
  const [prescriptionSchema, setPrescriptionSchema] =
    useState<AppointmentPrescriptionSchemaType>({
      ...defaultPrescriptionValues,
    });

  const form = useForm<AppointmentPrescriptionSchemaType>({
    resolver: zodResolver(AppointmentPrescriptionSchema),
    ...defaultPrescriptionValues,
  });
  function onSubmit(values: z.infer<typeof AppointmentPrescriptionSchema>) {
    console.log("Submitting prescription:", values);
    if (values.category.id === undefined) {
      toast.error("Please select a category");
    } else if (values.generic_name.id === undefined) {
      toast.error("Please select a generic name");
    } else if (values.drug_name.id === undefined) {
      toast.error("Please select a drug name");
    } else if (values.prescription_frequency.id === undefined) {
      toast.error("Please select a prescription frequency");
    } else if (values.prescription_length.id === undefined) {
      toast.error("Please select a prescription length");
    } else {
      let appointmentID: string =
        appointmentId === undefined ? "" : appointmentId;
      let brandDrugNameId: string =
        values.drug_name.id === undefined ? "" : values.drug_name.id;
      let frequencyId: string =
        values.prescription_frequency.id === undefined
          ? ""
          : values.prescription_frequency.id;
      let lengthId: string =
        values.prescription_length.id === undefined
          ? ""
          : values.prescription_length.id;
      let notes: string = values.notes === undefined ? "" : values.notes;

      addNewPrescriptionAppointment({
        appointmentId: appointmentID,
        drugNameId: brandDrugNameId,
        frequencyId: frequencyId,
        lengthId: lengthId,
        notes: notes,
      })
        .then((data) => {
          getPrescriptionData(appointmentID);
          toast.success("Prescription added to appointment successfully");
          form.reset();
          setPrescriptionSchema({ ...defaultPrescriptionValues });
        })
        .catch((error) => {
          toast.error("Unable to add prescription to appointment");
          console.log(error);
        });
    }
  }
  return (
    <Card>
      <CardHeader>
        <h2>Add Prescription to this Appointment</h2>
      </CardHeader>
      <CardContent>
        {/* Separator and new DrugName combobox form */}
        <BrandNamePrescription
          appointmentId={appointmentId}
          getPrescriptionData={getPrescriptionData}
        />
        {/* Fix this befor uncommenting */}
        {/* Custom separator with dot on the same line */}
        {/* <div className="flex items-center gap-2 my-4">
          <Separator className="flex-1" />
          <span className="mx-2 text-xl text-muted-foreground">OR</span>
          <Separator className="flex-1" />
        </div>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Category
              form={form}
              prescriptionSchema={prescriptionSchema}
              setPrescriptionSchema={setPrescriptionSchema}
            />
            {prescriptionSchema.category.id !== undefined ? (
              <GenericName
                form={form}
                prescriptionSchema={prescriptionSchema}
                setPrescriptionSchema={setPrescriptionSchema}
              />
            ) : null}
            {prescriptionSchema.generic_name.id !== undefined ? (
              <DrugName
                form={form}
                prescriptionSchema={prescriptionSchema}
                setPrescriptionSchema={setPrescriptionSchema}
              />
            ) : null}
            {prescriptionSchema.category.id !== undefined &&
            prescriptionSchema.generic_name.id !== undefined &&
            prescriptionSchema.drug_name.id !== undefined ? (
              <PrescriptionFrequency
                form={form}
                prescriptionSchema={prescriptionSchema}
                setPrescriptionSchema={setPrescriptionSchema}
              />
            ) : null}
            {prescriptionSchema.category.id !== undefined &&
            prescriptionSchema.generic_name.id !== undefined &&
            prescriptionSchema.drug_name.id !== undefined &&
            prescriptionSchema.prescription_frequency !== undefined ? (
              <PrescriptionLength
                form={form}
                prescriptionSchema={prescriptionSchema}
                setPrescriptionSchema={setPrescriptionSchema}
              />
            ) : null}
            {prescriptionSchema.prescription_length.id !== undefined ? (
              <Notes
                form={form}
                prescriptionSchema={prescriptionSchema}
                setPrescriptionSchema={setPrescriptionSchema}
              />
            ) : null}
            <Button className="my-4 bg-green-700 " type="submit">
              <IoMdAdd /> Add Prescription
            </Button>
          </form>
        </Form> */}
      </CardContent>
    </Card>
  );
}
